module.exports = __webpack_public_path__ + "static/media/luisprofile.0442017d.jpg";